/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Verify_Ticket_UsedInputs */

const en_verify_ticket_used = /** @type {(inputs: Verify_Ticket_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticket Used`)
};

const es_verify_ticket_used = /** @type {(inputs: Verify_Ticket_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticket Utilizado`)
};

const fr_verify_ticket_used = /** @type {(inputs: Verify_Ticket_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticket déjà utilisé`)
};

const de_verify_ticket_used = /** @type {(inputs: Verify_Ticket_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticket wurde bereits verwendet`)
};

const id_verify_ticket_used = /** @type {(inputs: Verify_Ticket_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiket Telah Digunakan`)
};

/** @type {(inputs: Verify_Ticket_UsedInputs) => LocalizedString} */
const ja_verify_ticket_used = en_verify_ticket_used;

/** @type {(inputs: Verify_Ticket_UsedInputs) => LocalizedString} */
const zh_verify_ticket_used = en_verify_ticket_used;

/** @type {(inputs: Verify_Ticket_UsedInputs) => LocalizedString} */
const ar_verify_ticket_used = en_verify_ticket_used;

/** @type {(inputs: Verify_Ticket_UsedInputs) => LocalizedString} */
const it_verify_ticket_used = en_verify_ticket_used;

/** @type {(inputs: Verify_Ticket_UsedInputs) => LocalizedString} */
const ru_verify_ticket_used = en_verify_ticket_used;

/** @type {(inputs: Verify_Ticket_UsedInputs) => LocalizedString} */
const pt_verify_ticket_used = en_verify_ticket_used;

/** @type {(inputs: Verify_Ticket_UsedInputs) => LocalizedString} */
const ko_verify_ticket_used = en_verify_ticket_used;

/**
* | output |
* | --- |
* | "Ticket Used" |
*
* @param {Verify_Ticket_UsedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const verify_ticket_used = /** @type {((inputs?: Verify_Ticket_UsedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Verify_Ticket_UsedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_verify_ticket_used(inputs)
	if (locale === "es") return es_verify_ticket_used(inputs)
	if (locale === "fr") return fr_verify_ticket_used(inputs)
	if (locale === "de") return de_verify_ticket_used(inputs)
	if (locale === "ja") return ja_verify_ticket_used(inputs)
	if (locale === "zh") return zh_verify_ticket_used(inputs)
	if (locale === "ar") return ar_verify_ticket_used(inputs)
	if (locale === "id") return id_verify_ticket_used(inputs)
	if (locale === "it") return it_verify_ticket_used(inputs)
	if (locale === "ru") return ru_verify_ticket_used(inputs)
	if (locale === "pt") return pt_verify_ticket_used(inputs)
	return ko_verify_ticket_used(inputs)
});